/**
 * AboutPage — Port of about.page.html from Ionic app
 */
const AboutPage = () => (
  <div style={{ padding: '16px', backgroundColor: '#f0f2f5', minHeight: '80vh' }}>
    {/* Header */}
    <div style={{ textAlign: 'center', padding: '20px', backgroundColor: '#090b72', borderRadius: '12px', marginBottom: '16px' }}>
      <img src="/images/paranthaman.png" alt="Logo" style={{ height: '80px', borderRadius: '12px', border: '2px solid rgba(212,168,69,0.5)', marginBottom: '8px' }} />
      <h1 style={{ color: 'white', fontSize: '1.3rem', margin: 0 }}>ஸ்ரீ பரந்தாமன் பஞ்சாங்கம்</h1>
      <p style={{ color: '#f0d48a', fontSize: '0.85rem', margin: '4px 0 0' }}>Version 7.0</p>
    </div>

    {/* About Card */}
    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ color: '#1b5e20', fontSize: '1.1rem', borderBottom: '2px solid #ff9800', paddingBottom: '6px' }}>எங்களைப் பற்றி</h2>
      <p style={{ color: '#333', fontSize: '0.9rem', lineHeight: 1.6 }}>
        Thank you so much for using this app.
        All information provided in this app are a collection of data from several astrological publications.
        No one in the team is a professional Astrologer.
      </p>
      <p style={{ color: '#333', fontSize: '0.9rem', lineHeight: 1.6 }}>
        <strong>We are not marketing anything.</strong> We do not collect or misuse any personal data of the users.
        Privacy of our users is highly respected.
      </p>
      <hr style={{ borderColor: '#ff9800', margin: '12px 0' }} />
      <p style={{ color: '#666', fontSize: '0.85rem' }}>This app is built with React and modern web technologies.</p>
    </div>

    {/* Team Card */}
    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ color: '#1b5e20', fontSize: '1.1rem', borderBottom: '2px solid #ff9800', paddingBottom: '6px' }}>குழு</h2>
      {[
        { name: 'Dr. N.V. Srinivasan', role: 'Developer & Content Creator' },
        { name: 'S. Sathyanarayanan', role: 'Backbone - Technical Support' },
        { name: 'S. Thirumalai Vadhyar', role: 'Panchangam Source Analyst, Debug - Tester' },
        { name: 'T. Vaidehi', role: 'Data Entry cum Program Assistant' },
        { name: 'T. Ajithkrishnan', role: 'App - Beta - Tester' },
      ].map((m, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 0', borderBottom: i < 4 ? '1px solid #eee' : 'none' }}>
          <span style={{ fontSize: '2rem' }}>👤</span>
          <div>
            <div style={{ fontWeight: 700, color: '#333' }}>{m.name}</div>
            <div style={{ fontSize: '0.8rem', color: '#666' }}>{m.role}</div>
          </div>
        </div>
      ))}
    </div>

    {/* Organization */}
    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ color: '#1b5e20', fontSize: '1.1rem', borderBottom: '2px solid #ff9800', paddingBottom: '6px' }}>Sri Vaishnava Kendram</h2>
      <p style={{ color: '#333', fontSize: '0.9rem', lineHeight: 1.6 }}>
        Sri Vaishnava Kendram provides services to its world wide customers.
        The Panchangam app is one of the many services offered for the benefit of
        the Vaishnava community and all devotees.
      </p>
    </div>

    {/* Donations */}
    <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '16px', marginBottom: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
      <h2 style={{ color: '#1b5e20', fontSize: '1.1rem', borderBottom: '2px solid #ff9800', paddingBottom: '6px' }}>நன்கொடை</h2>
      <p style={{ color: '#333', fontSize: '0.9rem' }}>Donations are not expected! If willing to contribute:</p>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', backgroundColor: '#e8f5e9', borderRadius: '8px', margin: '8px 0' }}>
        <span>💳</span>
        <span style={{ fontWeight: 600 }}>UPI: drnvs@icici or drnvs@upi</span>
      </div>
      <div style={{ textAlign: 'center', marginTop: '12px' }}>
        <img src="/images/qrcode-for-nvs-UPI.jpeg" alt="QR Code" style={{ maxWidth: '180px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }} />
      </div>
    </div>

    <div style={{ textAlign: 'center', padding: '16px', color: '#888', fontSize: '0.75rem' }}>
      © Sri Vaishnava Kendram. All rights reserved.
    </div>
  </div>
);

export default AboutPage;
